import { usePermissions } from './usePermissions';
import { useAppStore } from '../store/appStore';

/**
 * What the current user may do with automation flows (general.manageAutomationFlows):
 * view = see flows and runs; edit = create, edit, attach; admin = publish and delete.
 * Mirrors the server's route guards; owners can do everything.
 */
export function useFlowPermissions() {
  const { hasPermissionAtLeast } = usePermissions();
  const owner = useAppStore(s => s.businessRole) === 'owner';
  const at = (level: 'view' | 'edit' | 'admin') => owner || hasPermissionAtLeast('general.manageAutomationFlows', level);
  return { canView: at('view'), canEdit: at('edit'), canAdmin: at('admin') };
}
